import React from 'react';

const Hero = () => {
  return (
    <div className="mt-[78px]">
      <div className="relative flex items-center justify-center h-full sm:h-fit">
        <video
          className="w-full h-full object-contain sm:object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/workware-hero.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default Hero;
